export default "__VITE_ASSET__gj0dSKDd__"